import * as React from "react";
import { forwardRef } from "react";
const SvgProcessing = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C12.5523 22 13 21.5523 13 21C13 20.4477 12.5523 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12C22 6.48 17.52 2 12 2Z", fill: "#202324", fillOpacity: 0.6 }));
const ForwardRef = forwardRef(SvgProcessing);
export default ForwardRef;
